module.exports = __webpack_public_path__ + "img/smoking vapor.b6c0760c.png";